import { apiService } from '@shared/services/apiServices';
import type {
  ListClientsResponse,
  ListClientsParams,
} from '@epics/clientManagement/types/clientListType';
import clientEndpoints from './clientEndpoints';

const EMPTY_RESPONSE: ListClientsResponse = {
  data: [],
  pagination: {
    totalCount: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },
};

export const listClientApiService = {
  listClients: async (
    params?: ListClientsParams
  ): Promise<ListClientsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status) {
      queryParams.append('status', params.status);
    }
    if (params?.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      queryParams.append('endDate', params.endDate);
    }
    if (params?.sortBy) {
      queryParams.append('sortBy', params.sortBy);
    }
    if (params?.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder);
    }
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    const endpoint = `${clientEndpoints.CLIENTS}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiService.getAPI(endpoint);

    if (response.error) {
      return EMPTY_RESPONSE;
    }

    return response.data as ListClientsResponse;
  },
};
